var DevFeatures = /* @__PURE__ */ ((DevFeatures2) => {
  DevFeatures2["DW3425"] = "DW-3425";
  DevFeatures2["DW4259"] = "DW-4259";
  DevFeatures2["DW2783"] = "DW-2783";
  DevFeatures2["DW4199"] = "DW-4199";
  DevFeatures2["DW3958"] = "DW-3958";
  DevFeatures2["T3134"] = "T3-134";
  DevFeatures2["ST137"] = "ST-137";
  DevFeatures2["ST125"] = "ST-125";
  DevFeatures2["ST395"] = "ST-395";
  DevFeatures2["T3586"] = "T3-586";
  DevFeatures2["T3817"] = "T3-817";
  DevFeatures2["ST1265"] = "ST-1265";
  DevFeatures2["ST1943"] = "ST-1943";
  DevFeatures2["ST2161"] = "ST-2161";
  DevFeatures2["ST2312"] = "ST-2312";
  DevFeatures2["ST2635"] = "ST-2635";
  DevFeatures2["ST3099"] = "ST-3099";
  DevFeatures2["ST2327"] = "ST-2327";
  DevFeatures2["ST3417"] = "ST-3417";
  DevFeatures2["ST3606"] = "ST-3606";
  return DevFeatures2;
})(DevFeatures || {});
const DevFeaturesFromParams = {
  sportFavorites: "ST-137",
  betBuilder: "ST-395",
  newsportsearch: "ST-125",
  oneStepRegistration: "T3-586",
  enableBff: "ST-1265",
  appLoadStructure: "ST-1943",
  themeAlpha: "ST-2312"
  /* ST2312 */
};
export {
  DevFeatures,
  DevFeaturesFromParams
};
